export default function GTEX() {
    return (
        <div className="card">
            <h2>GT4 Xperience</h2>
            <p>Hier folgt später die GT4-Serie.</p>
        </div>
    );
}
